import React, { Component } from 'react';
import { withRouter } from 'utilities';
import logo from 'images/constellation-logo-trans-white-matte.png';
import logo2 from 'images/constellation-logo-2.JPG';
import { useAuth } from 'auth_context';

class PublicHeaderPage extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		let user = this.props.user;
		let logout_text = [];

		if (user) {
			logout_text = (
				<a className={`side-link`} onClick={this.props.auth.logout}>
					Log Out
				</a>
			);
		}
		return (
			<div className={`public-header ${this.props.selected === 'resources' ? 'with-sidebar' : ''}`}>
				<img
					src={logo}
					style={{ width: '300px', padding: '20px', cursor: 'pointer' }}
					alt="Logo"
					onClick={() => this.props.navigate('/')}
				/>
				{/*<img src={logo2} style={{ width: '140px', padding: '20px' }} alt="Logo" />*/}
				<div className="header-links">
					<a
						className={`nav-link ${this.props.selected === 'resources' ? 'selected' : ''}`}
						onClick={() => {
							this.props.navigate('/resources');
							this.props.select('resources');
						}}
					>
						Resources
					</a>
					{user && (
						<a
							className={`nav-link ${this.props.selected === 'map' ? 'selected' : ''}`}
							onClick={() => {
								this.props.navigate('/map');
								this.props.select('map');
							}}
						>
							Map
						</a>
					)}
					<a
						className={`nav-link ${this.props.selected === 'contact' ? 'selected' : ''}`}
						onClick={() => {
							this.props.navigate('/contact');
							this.props.select('contact');
						}}
					>
						Contact
					</a>
					<a
						className={`nav-link ${this.props.selected === 'about' ? 'selected' : ''}`}
						onClick={() => {
							this.props.navigate('/about');
							this.props.select('about');
						}}
					>
						About
					</a>
				</div>
				<div className="header-right">
					<a
						className={`side-link ${this.props.selected === 'login' ? 'selected' : ''}`}
						onClick={() => {
							this.props.navigate(user ? '/org_portal' : '/login');
							this.props.select('login');
						}}
					>
						{user ? user.name : 'Login'}
					</a>
					{logout_text || <br />}
				</div>
			</div>
		);
	}
}

const PublicHeader = props => {
	const auth = useAuth();
	return <PublicHeaderPage {...props} auth={auth} />;
};

export default withRouter(PublicHeader);
